import React from "react";
import { Box, Flex } from "../../components/Flex";
import { BarChart } from "../../components/charts/BarChart";
import moment from "moment";
import { ShcDatesPanel } from "./ShcDatesPanel";
import { RadioButtonGroup } from "../../components/Radio";
import { ShcIcon } from "../../icons/ShcIcon";
import { ListIcon } from "../../icons/ListIcon";
import { Table } from "../../components/Table";
import { Badge } from "../../components/Circle";
import { CircleIcon } from "../../icons/CircleIcon";
import { failedColor, strokeColor } from "../../components/charts/styles";
import { MarkText } from "../../components/MarkText";
import { formatDate } from "../../utils";
import { Link } from "react-router-dom";
import { toLower } from "lodash";
import { Checkbox } from "../../components/Checkbox";
import { Label } from "../../components/Text";
import { Page404 } from "../../components/Page404";


const ShcNode = ({ node, dates, interval, data, onlyFailed, showOnlyFailed, onDateChange, showFiles, onSwitchMode, pathname, loading, onChartBarClick, notFound }) => {
    const buttons = [
        { key: "chart", icon: <ShcIcon size={20} /> },
        { key: "files", icon: <ListIcon size={20} /> }
    ];

    const columns = [
        {
            title: <CircleIcon size={16} />,
            dataIndex: 'failed',
            render: (text, record, index) => <Badge color={Number(record.failed) > 0 ? failedColor : strokeColor} />,
            width: 56,
            sorter: (a, b) => a.failed - b.failed
        },
        {
            title: "Report Date",
            dataIndex: "date",
            width: 160,
            defaultSortOrder: "descend",
            render: (text, record, index) => <MarkText text={formatDate(text, "DD MMM YYYY HH:mm:ss")} />,
            sorter: (a, b) => { if (a && a.hasOwnProperty("date") && a.date) return a.date.localeCompare(b.date) },
        },
        {
            title: "File Name",
            dataIndex: "file",
            render: (text, record, index) => (
                <Link to={pathname + "/files/" + toLower(record.key)}>
                    <MarkText text={text} className="sp-table-row-clickable" />
                </Link>
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("file") && a.file) return a.file.localeCompare(b.file) }
        },
        {
            title: "Upload Date",
            dataIndex: "uploaded",
            width: 160,
            render: (text, record, index) => <MarkText text={formatDate(text, "DD MMM YYYY HH:mm:ss")} />,
            sorter: (a, b) => { if (a && a.hasOwnProperty("uploaded") && a.uploaded) return a.uploaded.localeCompare(b.uploaded) },
        },
        {
            title: "Total",
            dataIndex: "fired",
            width: 100,
            sorter: (a, b) => a.fired - b.fired,
        },
        {
            title: "Passed",
            dataIndex: "passed",
            width: 100,
            sorter: (a, b) => a.passed - b.passed,
        },
        {
            title: "Failed",
            dataIndex: "failed",
            width: 100,
            sorter: (a, b) => a.failed - b.failed,
        }
    ];

    if (notFound) {
        return <Page404 />
    };

    return(
        <Box
            flatten
            height="calc(100% - 52px)"
            gap={{ bottom: 16 }}
        >
            <Flex justify="space-between">
                <ShcDatesPanel
                    dates={dates}
                    interval={interval}
                    onChange={onDateChange}
                />
                <Flex gap={{ right: 16 }}>
                    <Checkbox checked={onlyFailed} onChange={e => showOnlyFailed(e.target.checked)}>
                        <Label bold capitalize>show only failed</Label>
                    </Checkbox>
                    <RadioButtonGroup buttons={buttons} value={showFiles ? "files" : "chart"} onChange={onSwitchMode} />
                </Flex>
            </Flex>
            <Flex height="calc(100% - 48px)">
                {showFiles
                    ? <Table
                            columns={columns}
                            loading={loading}
                            dataSource={Array.isArray(data) ? data : []}
                            emptyText={{ text: "No tests were fired for selected dates" }}
                        />
                    : <BarChart
                        onlyFailed={onlyFailed}
                        node={node}
                        loading={!(Array.isArray(data))}
                        data={data}
                        dateRange={[moment.utc(dates[0]).startOf("day"), moment.utc(dates[1]).endOf("day")]}
                        onBarClick={onChartBarClick}
                    />}
            </Flex>
        </Box>
    )
}

export { ShcNode }